import { isAdmin } from './isAdmin';
import { isReguladorWriter } from './isRegulador';
import { isRequesterWriter } from './isRequester';

export type CadernoLpmaFormEditFlags = {
	canEditDadosPrincipais: boolean;
	canEditOutrasAbas: boolean;
};

/**
 * Alinhado a Basf.Pdr.Domain.Security.SecurityRoles.CadernoLPMA e ao CadernoLpmaPermissionHelper (back-end).
 * Híbrido regulador.write + requisitante.write: bloqueia edição nas demais abas.
 */
export function getCadernoLpmaFormEditFlags(roles: string[] | undefined | null): CadernoLpmaFormEditFlags {
	const r = roles ?? [];
	const admin = isAdmin(r);
	const reguladorWrite = isReguladorWriter(r);
	const requisitanteWrite = isRequesterWriter(r);

	let canEditDadosPrincipais = admin || reguladorWrite;
	let canEditOutrasAbas = admin || requisitanteWrite;

	if (!admin && reguladorWrite) {
		canEditOutrasAbas = false;
	}
	if (!admin && requisitanteWrite && !reguladorWrite) {
		canEditDadosPrincipais = false;
	}

	return { canEditDadosPrincipais, canEditOutrasAbas };
}

/** Só admin / regulador (dados principais) criam caderno; requisitante edita apenas cadernos já existentes. */
export function canAdicionarCadernoLpma(roles: string[] | undefined | null): boolean {
	const { canEditDadosPrincipais } = getCadernoLpmaFormEditFlags(roles);
	return canEditDadosPrincipais;
}
